import { ReactNode } from 'react';
import { NavLink, NavLinkProps, useParams } from 'react-router-dom';

interface NavlinkWithTranslationProps extends NavLinkProps {
  children: ReactNode;
  to: string;
}

const NavlinkWithTranslation = ({ children, to, ...rest }: NavlinkWithTranslationProps) => {
  const { lang } = useParams();

  return (
    <NavLink to={`/${lang}/${to}`} {...rest}>
      {children}
    </NavLink>
  );
};

export default NavlinkWithTranslation;
